import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)




const routes = [{
    path: '/',
    // redirect: `/u/${defaultUserId}`,
    redirect: (to) => {
        // 从当前路径中提取 userId（如 /u/-16770 -> -16770）
        const match = to.path.match(/\/u\/(\d+)/);
        const userId = match ? match[1] : 'default';
        // const defaultUserId = window.location.pathname;
        // localStorage.setItem("userId", defaultUserId);

        return `/u/${userId}`;
    },
    meta: {
        title: '国研网'
    },
    component: () =>
        import ('@/views/home'),

    children: [{
            path: 'u/:userId',
            name: 'user-profile',
            meta: {
                title: '国研网'
            },
            component: () =>
                import ('@/components/defaultContent'),
            props: true,
            beforeEnter: (to, from, next) => {
                // 仅在此路由中执行逻辑
                // if (to.params.userId) {
                //     const defaultUserId = window.location.pathname;
                //     localStorage.setItem("userId", defaultUserId);
                //     next();
                // } else {
                //     next();
                // }

                const userId = to.params.userId;
                if (userId) {
                    // 将 userId 存储到 localStorage
                    localStorage.setItem('userId', '/u/' + userId);
                    localStorage.setItem(`userId${userId}`, userId);

                    next(); // 继续导航
                } else {
                    // 如果没有 userId，可以选择重定向到默认页面或处理错误
                    next('/'); // 重定向到首页
                }
            }
        },

        {
            path: 'list',
            meta: {
                title: '国研网'
            },
            component: () =>
                import ('@/views/list')
        }, {
            path: 'NavPage',
            meta: {
                title: '国研网'
            },
            component: () =>
                import ('@/views/NavPage')
        }
    ]
}]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
})

router.beforeEach(async(to, from, next) => {
    // localStorage.setItem('token', '329a6334e9d74fbc82bdf094f09aef6c');
    next()
})
router.afterEach((to, from, next) => {
    window,
    scrollTo(0, 0);
    document.title = to.meta.title;
})
export default router